import { render } from "./TabsModalServico.vue?vue&type=template&id=73cd8746"
import script from "./TabsModalServico.vue?vue&type=script&lang=js"
export * from "./TabsModalServico.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__